import * as React from 'react';

import { EditCount } from './review-list/edit-count';

import { StatusBadge } from '@/components/convos/status-badge';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export interface StatusSourceSummaryProps {
  isNew?: boolean;
  isAccepted?: boolean;
  editCount?: number;
  sourceIcon?: React.ReactNode;
  sourceDescription?: string | null;
  onSourceLinkClick?: () => void;
  sourceLabel?: string;
  className?: string;
}

export function StatusSourceSummary({
  isNew,
  isAccepted,
  editCount,
  sourceIcon,
  sourceDescription,
  onSourceLinkClick,
  sourceLabel = 'Open source',
  className,
}: StatusSourceSummaryProps) {
  let status: React.ReactNode | undefined;
  if (isAccepted) {
    status = <StatusBadge variant="accepted">Accepted</StatusBadge>;
  } else if (isNew) {
    status = (
      <StatusBadge variant="success" surface="transparent">
        New
      </StatusBadge>
    );
  } else if (editCount) {
    status = <EditCount count={editCount} />;
  }

  if (!status && !sourceIcon && !sourceDescription) {
    return null;
  }

  return (
    <span className={cn('flex items-center gap-1 leading-4 min-w-0', className)}>
      {status && <span className="shrink-0 flex items-center">{status}</span>}
      {sourceDescription &&
        (onSourceLinkClick ? (
          <Button
            variant="link"
            onClick={onSourceLinkClick}
            aria-label={sourceLabel}
            className="[&_svg]:size-4 h-auto p-0 text-xs font-normal text-subtle gap-1"
          >
            {sourceIcon && <span className="shrink-0 flex items-center">{sourceIcon}</span>}
            <span className="truncate">{sourceDescription}</span>
          </Button>
        ) : (
          <span className="[&_svg]:size-4 flex items-center gap-1 text-xs text-subtle min-w-0">
            {sourceIcon && <span className="shrink-0 flex items-center">{sourceIcon}</span>}
            <span className="truncate">{sourceDescription}</span>
          </span>
        ))}
    </span>
  );
}
